<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VBkcm3/tc-custom/9781466867765.jpg?1737745989706" alt="This image is the cover for the book The Dirt on Clean"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Dirt on Clean
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A spirited chronicle of the West's ambivalent relationship with dirt </b><br/><br/>The question of cleanliness is one every age and culture has answered with confidence. For the first-century Roman, being clean meant a two-hour soak in baths of various temperatures, scraping the body with a miniature rake, and a final application of oil. For the aristocratic Frenchman in the seventeenth century, it meant changing your shirt once a day and perhaps going so far as to dip your hands in some water. Did Napoleon know something we didn't when he wrote Josephine "I will return in five days. Stop washing"? And why is the German term <i>Warmduscher</i>—a man who washes in warm or hot water—invariably a slight against his masculinity? Katherine Ashenburg takes on such fascinating questions as these in <i>Dirt on Clean</i>, her charming tour of attitudes to hygiene through time.<br/><br/>What could be more routine than taking up soap and water and washing yourself? And yet cleanliness, or the lack of it, is intimately connected to ideas as large as spirituality and sexuality, and historical events that include plagues, the Civil War, and the discovery of germs. An engrossing fusion of erudition and anecdote, <i>Dirt on Clean</i> considers the bizarre prescriptions of history's doctors, the hygienic peccadilloes of great authors, and the historic twists and turns that have brought us to a place Ashenburg considers hedonistic yet oversanitized.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katherine Ashenburg
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f3988a4